import { AggregateScoresEdges } from "~/pages/reports/SecurityReport/utils/securityReportTypes";
import {
  alpha,
  Box,
  List,
  ListItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { getColor } from "~/lib/colors";
import { RankCircle } from "~/components/Cells";
import { ImpactUpdated } from "~/components/impact/Updated/impact-updated";

interface InventoryListProps {
  softwareEdges: AggregateScoresEdges;
}

export function SecurityReportInventoryList({
  softwareEdges,
}: InventoryListProps) {
  const theme = useTheme();
  const top5 = softwareEdges?.slice(0, 5) || [];

  return (
    <List sx={{ columns: 2 }}>
      {top5.map((edge) => {
        const { node } = edge;
        const { rank, rating, riskValue, title } = node || {};

        let UNKNOWN_RATING = "";
        if (!rating) {
          UNKNOWN_RATING = "UNKNOWN";
        }

        const color = getColor(theme, rating || UNKNOWN_RATING);
        return (
          <ListItem
            sx={{
              display: "inline-flex",
              justifyContent: "space-between",
            }}
          >
            <Stack direction="row" gap={5}>
              <RankCircle id={rank || "NA"} />
              {rating && riskValue != null ? (
                <ImpactUpdated
                  impact={{ rating, value: riskValue }}
                  isRiskScore
                  hideTooltip={true}
                />
              ) : (
                <Typography>{UNKNOWN_RATING}</Typography>
              )}
              <Typography>{title}</Typography>
            </Stack>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 1,
                py: 0.5,
                width: 48,
                borderRadius: 1,
                backgroundColor: alpha(color, 0.1),
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600, color }}>
                865
              </Typography>
            </Box>
          </ListItem>
        );
      })}
    </List>
  );
}
